<button class="back-button" (click)="back()">
  <mat-icon>keyboard_arrow_left</mat-icon>
  Back
</button>

<div class="d-flex justify-content-center align-items-center w-100 mt-2 mx-2">
    <div *ngIf="payment" style="width:100%; max-width: 700px">
        <h2>Payment</h2>
        <div>{{ payment.id }}</div>
        <div *ngIf="user">
          <span *ngIf="payment.sender == user.id" class="badge bg-success">Sender</span>
          <span *ngIf="payment.receiver == user.id" class="badge bg-danger">Receiver</span>
        </div>
        <div>Type: {{ payment.type }}</div>
        <div>Amount: {{ payment.amount | currency:payment.currency?payment.currency:'PHP' }}</div>
        <div>Payments: {{ payment.intervals }}</div>
        <div>Frequency: {{ payment.intervalPeriod }} <span *ngIf="payment.intervalUnit == 'MONTH'">Month</span><span *ngIf="payment.intervalPeriod > 1">s</span></div>
        <div *ngIf="payment.senderDetail">Sender: <a [routerLink]="'/admin-users/' + payment.sender">{{ payment.senderDetail.fullName }}</a></div>
        <div *ngIf="payment.receiverDetail">Receiver: <a [routerLink]="'/admin-users/' + payment.receiver">{{ payment.receiverDetail.fullName }}</a></div>
        <div *ngIf="payment.complete">Complete
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-circle-fill"
              viewBox="0 0 16 16">
              <path
                d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
            </svg>
        </div>
        <div *ngIf="payment.settled">Settled
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-circle-fill"
              viewBox="0 0 16 16">
              <path
                d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
            </svg>
        </div>
        <div *ngIf="payment.type == 'PAYMENT_TO_BILLER' && payment.settle == user.id" ><button (click)="pay()">Pay</button></div>
        <div *ngIf="payment.type == 'PAYMENT_TO_BILLER' && !payment.settled" ><button (click)="settle()">Settle</button></div>
        <table *ngIf="payment.bookings">
            <tr>
                <th>Id</th>
                <th>Date</th>
                <th>Complete</th>
            </tr>
            <tr *ngFor="let booking of payment.bookings">
                <td>{{ booking.id }}</td>
                <td>{{ booking.date | date }}</td>
                <td>{{ booking.complete }}</td>
            </tr>
        </table>
    </div>
    <div *ngIf="!payment">
        Loading Payment
    </div>
</div>
